import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import axios from 'axios';
import Properties from "../const/Properties";
import {withRouter} from "react-router-dom";

const active = {fiyatlandirma: "active"};

class Fiyatlandirma extends React.Component {


    constructor(props) {
        super(props);
        if (localStorage.getItem("token") == "") {
            window.location = '/';
            return false;
        }
        this.state = {
            secilenUlke: "Trieste",
            secilenUlkeId: 1,
            gemiUcretiTarife: 0,
            bafTarife: 0,
            etsTarife: 0,
            limanTarife: 0,
            soforUcretiTarifeGemi: 0,
            soforUcretiTarifeUcak: 0,
            ekSoforTarifeGemi: 0,
            ekSoforTarifeUcak: 0,
            xrayTarife: 0,
            yaniciTarife: 0,
            rezervasyonTarife: 0,
            sigorta1ay: 0,
            sigorta2ay: 0,
            sigorta3ay: 0,
            hizmetBedeli: 0,
            ens: 0,
            gurbulak: 0,
            esendere: 0,
            dilucu: 0,
            surucuAdi: "",
            karneNumarasi: "",
            pasaportNumarasi: "",
            geldigiGumruk: "",
            gemiAdi: "",
            muhurNumarasi: "",
            gidecegiUlke: "",
            kapAdeti: 0,
            kg: 0,
            yukCinsi: "",
            content: [],
            pageCount: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            silModal: 'none',
            title: ["STATU", "TARİH", "ÇEKİCİ PLAKA", "İŞLEM ÜCRETİ", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
    }
    componentDidMount() {
        if(this.props.match.params.id != undefined)
        {
            this.setState({secilenUlkeId:this.props.match.params.id});
        }
        this.get();
    }
    onChange = e => {
        this.setState({[e.target.name]: e.target.value})
    }
    ulkeSec = e => {
        window.location = "/fiyatlandirma/"+e;
    }
    tarifeSave = e => {
        let status = true;
        if (status) {
            axios({
                method: 'post',
                url: Properties.baseUrl + '/tarife/save',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                data: {
                    gemiUcretiTarife: this.state.gemiUcretiTarife,
                    bafTarife: this.state.bafTarife,
                    etsTarife: this.state.etsTarife,
                    limanTarife: this.state.limanTarife,
                    soforUcretiTarifeGemi: this.state.soforUcretiTarifeGemi,
                    soforUcretiTarifeUcak: this.state.soforUcretiTarifeUcak,
                    ekSoforTarifeGemi: this.state.ekSoforTarifeGemi,
                    ekSoforTarifeUcak: this.state.ekSoforTarifeUcak,
                    xrayTarife: this.state.xrayTarife,
                    yaniciTarife: this.state.yaniciTarife,
                    rezervasyonTarife: this.state.rezervasyonTarife,
                    sigorta1ay: this.state.sigorta1ay,
                    sigorta2ay: this.state.sigorta2ay,
                    sigorta3ay: this.state.sigorta3ay,
                    gurbulak: this.state.gurbulak,
                    esendere: this.state.esendere,
                    ens: this.state.ens,
                    hizmetBedeli: this.state.hizmetBedeli,
                    dilucu: this.state.dilucu,
                    ulke: this.state.secilenUlkeId,
                }
            })
                .then(res => {
                    window.successful((this.state.showDuzenle ? "Tarife Güncellendi." : "Tarife Kaydedildi"));
                    this.get();

                }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Tarife Güncellenemedi." : "Tarife Kaydedilemedi."));
                this.get();

            });
            this.get();
        }
    }
    get = e => {
        let status = true;
        let secilenUlkeId= 0
        if(this.props.match.params.id != undefined)
        {
            secilenUlkeId=  this.props.match.params.id;
        }
        else {
            secilenUlkeId = 1
        }
        if (status) {
            axios({
                method: 'get',
                url: Properties.baseUrl + '/tarife/get/'+secilenUlkeId,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            })
                .then(res => {
                    this.setState({gemiUcretiTarife: res.data.gemiUcretiTarife});
                    this.setState({bafTarife: res.data.bafTarife});
                    this.setState({etsTarife: res.data.etsTarife});
                    this.setState({limanTarife: res.data.limanTarife});
                    this.setState({soforUcretiTarifeGemi: res.data.soforUcretiTarifeGemi});
                    this.setState({soforUcretiTarifeUcak: res.data.soforUcretiTarifeUcak});
                    this.setState({ekSoforTarifeGemi: res.data.ekSoforTarifeGemi});
                    this.setState({ekSoforTarifeUcak: res.data.ekSoforTarifeUcak});
                    this.setState({xrayTarife: res.data.xrayTarife});
                    this.setState({yaniciTarife: res.data.yaniciTarife});
                    this.setState({rezervasyonTarife: res.data.rezervasyonTarife});
                    this.setState({sigorta1ay: res.data.sigorta1ay});
                    this.setState({sigorta2ay: res.data.sigorta2ay});
                    this.setState({sigorta3ay: res.data.sigorta3ay});
                    this.setState({gurbulak: res.data.gurbulak});
                    this.setState({esendere: res.data.esendere});
                    this.setState({ens: res.data.ens});
                    this.setState({hizmetBedeli: res.data.hizmetBedeli});
                    this.setState({dilucu: res.data.dilucu});
                }).catch(res => {
                window.unsuccessful((this.state.showDuzenle ? "Tarife Güncellenemedi." : "Tarife Kaydedilemedi."));
            });
        }
    }

    render(props) {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu fiyatlandirma="active" yonetim="menu-is-opening menu-open"  yonetimacik={{display:'Block'}}/>
                <PageContext>
                    <div className="card">
                        <div className="row">
                            <div className="col-1">
                                <button onClick={e => this.ulkeSec(1)}
                                        style={this.state.showDuzenle ? {display: 'none'} : {
                                            margin: "10px",
                                            display: 'block'
                                        }} type="button" className={this.state.secilenUlkeId==1 ? "btn btn-primary" : "btn btn-outline-primary"} >Trieste
                                </button>
                            </div>
                            <div className="col-1">
                                <button onClick={e => this.ulkeSec(2)}
                                        style={this.state.showDuzenle ? {display: 'none'} : {
                                            margin: "10px",
                                            display: 'block'
                                        }} type="button"  className={this.state.secilenUlkeId==2 ? "btn btn-primary" : "btn btn-outline-primary"}>Bari
                                </button>
                            </div>
                            <div className="col-1">
                                <button onClick={e => this.ulkeSec(3)}
                                        style={this.state.showDuzenle ? {display: 'none'} : {
                                            margin: "10px",
                                            display: 'block'
                                        }} type="button"  className={this.state.secilenUlkeId==3 ? "btn btn-primary" : "btn btn-outline-primary"}>Sete
                                </button>
                            </div>
                        </div>

                        <div className="card-header">
                            <h3 className="card-title">{this.state.secilenUlke} Bilgileri</h3>
                        </div>
                        <div className="card-body">
                            <table id="table" className="table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>TARİFE ADI</th>
                                    <th>FİYAT</th>
                                    <th>İŞLEM</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>GEMİ ÜCRETİ</td>
                                    <td>
                                        {this.state.gemiUcretiTarife} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="gemiUcretiTarife"
                                               onChange={this.onChange} value={this.state.gemiUcretiTarife}
                                               placeholder="Gemi Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                <td>BAF ÜCRETİ</td>
                                    <td>
                                        {this.state.bafTarife} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="bafTarife"
                                               onChange={this.onChange} value={this.state.bafTarife}
                                               placeholder="BAF Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>ETS ÜCRETİ</td>
                                    <td>
                                        {this.state.etsTarife} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="etsTarife"
                                               onChange={this.onChange} value={this.state.etsTarife}
                                               placeholder="ETS Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>LİMAN ÜCRETİ</td>
                                    <td>
                                        {this.state.limanTarife} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="limanTarife"
                                               onChange={this.onChange} value={this.state.limanTarife}
                                               placeholder="LİMAN Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>ŞOFÖR GEMİ ÜCRETİ</td>
                                    <td>
                                        {this.state.soforUcretiTarifeGemi} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="soforUcretiTarifeGemi"
                                               onChange={this.onChange} value={this.state.soforUcretiTarifeGemi}
                                               placeholder="ŞOFÖR GEMİ Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>ŞOFÖR UÇAK ÜCRETİ</td>
                                    <td>
                                        {this.state.soforUcretiTarifeUcak} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="soforUcretiTarifeUcak"
                                               onChange={this.onChange} value={this.state.soforUcretiTarifeUcak}
                                               placeholder="ŞOFÖR UÇAK Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>EK ŞOFÖR GEMİ ÜCRETİ</td>
                                    <td>
                                        {this.state.ekSoforTarifeGemi} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="ekSoforTarifeGemi"
                                               onChange={this.onChange} value={this.state.ekSoforTarifeGemi}
                                               placeholder="EK ŞOFÖR GEMİ Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>EK ŞOFÖR UÇAK ÜCRETİ</td>
                                    <td>
                                        {this.state.ekSoforTarifeGemi} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="ekSoforTarifeUcak"
                                               onChange={this.onChange} value={this.state.ekSoforTarifeUcak}
                                               placeholder="EK ŞOFÖR UÇAK Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>XRAY ÜCRETİ</td>
                                    <td>
                                        {this.state.xrayTarife} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="xrayTarife"
                                               onChange={this.onChange} value={this.state.xrayTarife}
                                               placeholder="XRAY Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>YANICI ÜCRETİ</td>
                                    <td>
                                        {this.state.yaniciTarife} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="yaniciTarife"
                                               onChange={this.onChange} value={this.state.yaniciTarife}
                                               placeholder="YANICI Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>REZERVASYON ÜCRETİ</td>
                                    <td>
                                        {this.state.rezervasyonTarife} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="rezervasyonTarife"
                                               onChange={this.onChange} value={this.state.rezervasyonTarife}
                                               placeholder="REZERVASYON Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>SİGORTA 1 AY</td>
                                    <td>
                                        {this.state.sigorta1ay} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="sigorta1ay"
                                               onChange={this.onChange} value={this.state.sigorta1ay}
                                               placeholder="REZERVASYON Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>SİGORTA 2 AY</td>
                                    <td>
                                        {this.state.sigorta2ay} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="sigorta2ay"
                                               onChange={this.onChange} value={this.state.sigorta2ay}
                                               placeholder="REZERVASYON Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>SİGORTA 3 AY</td>
                                    <td>
                                        {this.state.sigorta3ay} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="sigorta3ay"
                                               onChange={this.onChange} value={this.state.sigorta3ay}
                                               placeholder="REZERVASYON Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>ENS</td>
                                    <td>
                                        {this.state.ens} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="ens"
                                               onChange={this.onChange} value={this.state.ens}
                                               placeholder="ENS Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>HİZMET BEDELİ</td>
                                    <td>
                                        {this.state.hizmetBedeli} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="hizmetBedeli"
                                               onChange={this.onChange} value={this.state.hizmetBedeli}
                                               placeholder="Hizmet Bedeli Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>GÜRBULAK</td>
                                    <td>
                                        {this.state.gurbulak} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="gurbulak"
                                               onChange={this.onChange} value={this.state.gurbulak}
                                               placeholder="REZERVASYON Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>ESENDERE</td>
                                    <td>
                                        {this.state.esendere} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="esendere"
                                               onChange={this.onChange} value={this.state.esendere}
                                               placeholder="REZERVASYON Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <td>DİLUCU</td>
                                    <td>
                                        {this.state.dilucu} €
                                    </td>
                                    <td>
                                        <input type="number" className="form-control" name="dilucu"
                                               onChange={this.onChange} value={this.state.dilucu}
                                               placeholder="REZERVASYON Ücreti"/>
                                    </td>
                                </tr>
                                <tr>
                                    <button style={{margin: "10px", width: "200px"}} type="button"
                                            onClick={e => this.tarifeSave(e)}
                                            className="btn btn-block btn-outline-info">FİYATLARI GÜNCELLE
                                    </button>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th>TARİFE ADI</th>
                                    <th>FİYAT</th>
                                    <th>İŞLEM</th>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </PageContext>
                <Footer/>
            </div>);
    }
}


export default withRouter(Fiyatlandirma);
